const dateFormat = (language?: string) =>
    new Intl.DateTimeFormat(language, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

const dateFormatWithTime = (language?: string) =>
    new Intl.DateTimeFormat(language, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

/**
 * DateFormat YYYY-MM-DD
 * Can be used in {@link formatDateWithFormat}
 */
export const dateFormatYearMonthDay = new Intl.DateTimeFormat('fr-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});

/**
 * Format Date with a certain format
 *
 * @param date date to be formatted
 * @param format format to be used
 * @returns date as text
 */
export const formatDateWithFormat = (date: Date, format: Intl.DateTimeFormat): string => format.format(date);

/**
 * Parse a date input which can be a Date object or a string of YYYY-MM-DD
 * @param date date to be parsed
 * @returns parsed Date object
 */
export const parseDateInput = (date: Date | string): Date => {
    if (date instanceof Date) {
        return date;
    }

    const localDateFormatMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
    if (localDateFormatMatch) {
        const [, year, month, day] = localDateFormatMatch;

        return new Date(Number(year), Number(month) - 1, Number(day));
    }

    return new Date(date);
};

export const formatDate = (date: Date | string, showTime = false, language?: string): string => {
    if (!date) {
        return '';
    }

    return formatDateWithFormat(
        parseDateInput(date),
        showTime ? dateFormatWithTime(language) : dateFormat(language)
    );
};
